var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_setup.copyToClipboard}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)]}}])},'v-tooltip',_vm.$attrs,false),[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }